// extracted by mini-css-extract-plugin
export default {"Error":"error__Error__TBR6f","kf_shake":"error__kf_shake__Q601e","FullPageError":"error__FullPageError__hgXp5 error__Error__TBR6f"};